module.exports = {
  HtmlContent: {
    PluginName: "Contenido HTML",
  },
};
